import React, { useState } from "react";
import Modal from "react-modal";
import { customStylesModal } from "./ConfirmModal";
import { useCalls } from "@stream-io/video-react-sdk";
import { CallingState } from "@stream-io/video-react-sdk";
import { useStream } from "../hooks/useStream";
import { useRouter } from "../hooks/useRouter";
import { useAuth } from "../hooks/useAuth";

const DialogIncomingCall = () => {
    const {onJoinCall, idsCallsIgnored, addIdsCallsIgnored} = useStream();
    const calls = useCalls();
    const { navigateToCall } = useRouter();
    const { currentUserId } = useAuth();
    
    const incomingCalls = calls.filter(
        (call) =>
        call.isCreatedByMe === false &&
        call.state.callingState === CallingState.RINGING,
    );
    const [incomingCall] = incomingCalls;
    const createdBy = incomingCall?.state.createdBy;

    const image = createdBy?.image;
    const name = createdBy?.name;
    const isOpen = incomingCall !== undefined && !idsCallsIgnored.includes(incomingCall?.id);

    const onClose = () => {
        addIdsCallsIgnored(incomingCall?.id);
    }

    const onAccept = () => {
        incomingCall?.join()
            .then(() => {
                onJoinCall(currentUserId ?? '', incomingCall);
                navigateToCall();
                incomingCall?.microphone.enable();
            });
    }

    const onDecline = () => {
        incomingCall?.reject();
    }

    return (
        <Modal isOpen={isOpen} onRequestClose={onClose} style={customStylesModal('440px')}>
            <div className="p-4 flex flex-col gap-12 items-center justify-center">
                <div className="flex flex-col gap-4 items-center justify-center pt-4">
                    <div className="w-[200px] h-[200px] rounded-full overflow-hidden">
                        <img src={image} className="w-full h-full object-cover" />
                    </div>
                    <h1 className="text-3xl font-semibold">{name}</h1>
                </div>
                <div className="flex flex-row gap-16 justify-center items-center">
                    <div className="flex flex-col items-center justify-center gap-2">
                        <button onClick={onAccept} className="bg-green-500 text-white rounded-full w-[70px] h-[70px] flex items-center justify-center hover:bg-green-600">
                            <span className="material-symbols-outlined text-3xl">
                                call
                            </span>
                        </button>
                        <p className="text-md">Accept</p>
                    </div>
                    <div className="flex flex-col items-center justify-center gap-2">
                        <button onClick={onDecline} className="bg-red-500 text-white rounded-full w-[70px] h-[70px] flex items-center justify-center hover:bg-red-600">
                            <span className="material-symbols-outlined text-3xl">
                                close
                            </span>
                        </button>
                        <p className="text-md">Decline</p>
                    </div>
                </div>
            </div>
        </Modal>
    );
}

export default DialogIncomingCall;